"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DELIMITER = ';';
/**
 * Разделение строки с запросами на массив запросов
 */
class QuerySplitter {
    constructor() {
        // Результат разбиения
        this.result = [];
    }
    /**
     * Разделение строки с запросами на запросы
     *
     * @param queriesString
     */
    split(queriesString) {
        this.source = queriesString;
        this.init();
        while (!this.isSourceEnd(this.current)) {
            if (this.isStringLiteral()) {
                this.readStringLiteral();
            }
            else if (this.isSingleLineComment()) {
                this.readSingleLineComment();
            }
            else if (this.isMultiLineComment()) {
                this.readMultiLineComment();
            }
            else if (this.isDollarLiteral()) {
                this.readDollarLiteral();
            }
            if (this.isQueryEnd()) {
                this.addQuery();
            }
            this.moveNext();
        }
        return this.result;
    }
    /**
     * Инициализация состояния начальными значениями
     */
    init() {
        this.result = [];
        this.start = 0;
        this.current = 0;
    }
    /**
     * Переход к следующему символу
     */
    moveNext() {
        this.current++;
    }
    /**
     * Проверка окончания очередного SQL запроса
     */
    isQueryEnd() {
        return this.isSourceEnd(this.current + 1) || this.source[this.current] === DELIMITER;
    }
    /**
     * Добавление считанного запроса в массив с запросами
     */
    addQuery() {
        const sqlText = this.source.substring(this.start, this.current >= this.source.length - 1 ? this.source.length : this.current + 1);
        const lineStart = this.source.substring(0, this.start + 1).split(/\r\n|\r|\n/).length;
        const id = Date.now().toString(36) + Math.random().toString(36).substr(2);
        this.result.push({
            id,
            lineStart,
            text: sqlText,
        });
        this.start = this.current + 1;
    }
    /**
     * Проверка, что с текущего символа начинается однострочный комментарий
     */
    isSingleLineComment() {
        return this.source[this.current] === '-' && this.source[this.current + 1] === '-';
    }
    /**
     * Вычитывание однострочного комментария до конца
     */
    readSingleLineComment() {
        do {
            this.current++;
        } while (this.isSourceEnd(this.current) || this.source[this.current] !== '\n');
    }
    /**
     * Проверка, что с текущего символа начинается многострочный комментарий
     */
    isMultiLineComment() {
        return this.source[this.current] === '/' && this.source[this.current + 1] === '*';
    }
    /**
     * Вычитывание многострочного комментария до конца
     */
    readMultiLineComment() {
        const isCommentEnd = () => this.source[this.current] === '*' && this.source[this.current + 1] === '/';
        // Пропускаем /*
        this.current += 2;
        while (!this.isSourceEnd(this.current + 1) && !isCommentEnd()) {
            this.current++;
        }
        // Пропускаем символ * из */
        if (isCommentEnd()) {
            this.current++;
        }
    }
    /**
     * Проверка, что с текущего символа начинается строковая константа в ''
     */
    isStringLiteral() {
        return this.source[this.current] === "'";
    }
    /**
     * Вычитывание строкового литерала до конца
     */
    readStringLiteral() {
        do {
            this.current++;
        } while (!this.isSourceEnd(this.current) &&
            (this.source[this.current] !== "'" || this.source[this.current - 1] === '\\'));
    }
    /**
     * Проверка, что с текущего символа начинается строковая константа через $tag$
     */
    isDollarLiteral() {
        return this.source[this.current] === '$';
    }
    /**
     * Вычитывание литерала через $tag$
     */
    readDollarLiteral() {
        const isLetter = (s) => !!s.match(/[a-z]/i);
        const isLetterOrNumber = (s) => !!s.match(/[a-z0-9]/i);
        const startOpenTagIndex = this.current;
        let tag = '$';
        this.current++;
        const nextChar = this.source[this.current];
        if (nextChar === '$') {
            tag = '$$';
        }
        else {
            while (!this.isSourceEnd(this.current) && this.source[this.current] !== '$') {
                const ch = this.source[this.current];
                const checkFn = this.current === startOpenTagIndex + 1 ? isLetter : isLetterOrNumber;
                if (!checkFn(ch)) {
                    // Недопустимый символ для идентификатора, перематываем в самый конец, оставшаяся часть запроса невалидная
                    this.moveToEnd();
                    return;
                }
                this.current++;
            }
            if (this.source[this.current] === '$') {
                tag = this.source.substring(startOpenTagIndex, this.current + 1);
            }
            else {
                // вычитали исходную строку до конца
                return;
            }
        }
        // Переводим на первый символ после $$
        this.current++;
        // Считываем все до закрывающего тега
        while (!this.isSourceEnd(this.current)) {
            if (this.source[this.current] === '$') {
                const closeTag = this.source.substr(this.current, tag.length);
                // Наткнулись на закрывающий тег
                if (closeTag === tag) {
                    this.current += tag.length - 1;
                    return;
                }
            }
            this.current++;
        }
    }
    /**
     * Перемещаем курсор в конец исходной строки с запросами
     */
    moveToEnd() {
        this.current = this.source.length - 1;
    }
    /**
     * Проверка, что строка с запросами обработана полностью
     *
     * @param n - текущий обрабатываемый символ
     */
    isSourceEnd(n) {
        return this.source.length <= n;
    }
}
exports.default = QuerySplitter;
//# sourceMappingURL=QuerySplitter.js.map